// extracted by mini-css-extract-plugin
export default {"judges-homepage-box":"index_judges-homepage-box__p4JMi"};